"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENTS = void 0;
var EVENTS = {
  click: 'onClick',
  dblclick: 'onDoubleClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mousemove: 'onMouseMove',
  mouseover: 'onMouseOver',
  beforepaste: 'onBeforePaste',
  paste: 'onPaste',
  cut: 'onCut',
  copy: 'onCopy',
  selectionchange: 'onSelectionChange',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  keydown: 'onKeyDown',
  keypress: 'onKeyPress',
  keyup: 'onKeyUp',
  contextmenu: 'onContextMenu',
  dragend: 'onDragEnd',
  dragover: 'onDragOver',
  draggesture: 'onDragGesture',
  dragdrop: 'onDragDrop',
  drop: 'onDrop',
  drag: 'onDrag',
  BeforeRenderUI: 'onBeforeRenderUI',
  SetAttrib: 'onSetAttrib',
  PreInit: 'onPreInit',
  PostRender: 'onPostRender',
  init: 'onInit',
  deactivate: 'onDeactivate',
  activate: 'onActivate',
  NodeChange: 'onNodeChange',
  BeforeExecCommand: 'onBeforeExecCommand',
  ExecCommand: 'onExecCommand',
  show: 'onShow',
  hide: 'onHide',
  ProgressState: 'onProgressState',
  LoadContent: 'onLoadContent',
  SaveContent: 'onSaveContent',
  BeforeSetContent: 'onBeforeSetContent',
  SetContent: 'onSetContent',
  BeforeGetContent: 'onBeforeGetContent',
  GetContent: 'onGetContent',
  VisualAid: 'onVisualAid',
  remove: 'onRemove',
  submit: 'onSubmit',
  reset: 'onReset',
  BeforeAddUndo: 'onBeforeAddUndo',
  AddUndo: 'onAddUndo',
  AppUndo: 'onAppUndo',
  AppRedo: 'onAppRedo',
  BeforeBookmark: 'onBeforeBookmark',
  change: 'onChange',
  undo: 'onUndo',
  redo: 'onRedo',
  ClearUndos: 'onClearUndos',
  ObjectSelected: 'onObjectSelected',
  ObjectResizeStart: 'onObjectResizeStart',
  ObjectResized: 'onObjectResized',
  PreProcess: 'onPreProcess',
  PostProcess: 'onPostProcess',
  focus: 'onFocus',
  blur: 'onBlur',
  dirty: 'onDirty',
  transformerAlert: 'onTransformAlert'
};
exports.EVENTS = EVENTS;